"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOURS_AFTER_ARRIVAL_TO_STOP_TRACKING_AUTOMATICALLY = exports.HOURS_AFTER_DEPARTURE_TO_STOP_TRACKING_AUTOMATICALLY = exports.HOURS_BEFORE_DEPARTURE_TO_SHOW_TRACKING = exports.TRACKING_DEPARTURE_LOOKAHEAD_HOURS = exports.TRACKING_DEPARTURE_LOOKBACK_HOURS = void 0;
exports.TRACKING_DEPARTURE_LOOKBACK_HOURS = 72;
exports.TRACKING_DEPARTURE_LOOKAHEAD_HOURS = 12;
exports.HOURS_BEFORE_DEPARTURE_TO_SHOW_TRACKING = 3;
exports.HOURS_AFTER_DEPARTURE_TO_STOP_TRACKING_AUTOMATICALLY = 12;
exports.HOURS_AFTER_ARRIVAL_TO_STOP_TRACKING_AUTOMATICALLY = 3;
//# sourceMappingURL=trip-tracking.js.map